import { useRef, useEffect } from "react";
import PlatformScreenshotsCarousel from "./PlatformScreenshotsCarousel";
const PlatformShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const revealElements = entry.target.querySelectorAll('.reveal');
          revealElements.forEach(element => {
            element.classList.add('active');
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-24 bg-background" id="platform">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 reveal">See FlatJive in action</h2>
          <p className="text-xl text-foreground max-w-3xl mx-auto reveal">
            Discover how FlatJive simplifies leaseholder management with our comprehensive platform. From budget planning to bank connections, see every feature in action.
          </p>
        </div>

        <div className="reveal">
          <PlatformScreenshotsCarousel />
        </div>

        <div className="mt-16 text-center reveal">
          <p className="text-lg text-foreground max-w-2xl mx-auto">
            Each feature is designed to reduce the complexity of property management while keeping 
            all leaseholders informed and engaged in the decision-making process.
          </p>
        </div>
      </div>
    </section>;
};
export default PlatformShowcase;